import { cx } from '@linaria/core';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useComponentFrameworkState } from '@provider/component-framework';
import { resets } from '@ui/css';
import { IsomorphicPortal } from '@utils/react';
import { TRANSITION_DURATION_MS } from '../tooltip/constants.js';
import { usePosition } from './hook.position.js';
import { popperCls, containerCls, arrowCls } from './overlay.styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Overlay(props) {
  const {
    floating,
    arrowRef
  } = usePosition(props);
  const targetSelector = useComponentFrameworkState(state => state.overlayContainerSelector);
  const target = targetSelector && document.querySelector(targetSelector) || props.mountIn;

  // If nothing else has been specified, then we should display an arrow by
  // default.
  const withArrow = props.withArrow === undefined ? true : props.withArrow;
  return /*#__PURE__*/jsx(IsomorphicPortal, {
    target: target,
    children: /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: props.active && /*#__PURE__*/jsx(CSSTransition, {
        timeout: TRANSITION_DURATION_MS,
        classNames: popperCls,
        nodeRef: floating.refs.floating,
        children: /*#__PURE__*/jsx("div", {
          className: cx(resets.rootCls, popperCls, props.className),
          "data-placement": floating.placement,
          ref: floating.refs.setFloating,
          style: {
            position: floating.strategy,
            left: floating.x ?? 0,
            top: floating.y ?? 0
          },
          children: /*#__PURE__*/jsxs("div", {
            className: containerCls,
            "data-popper-container": true,
            children: [withArrow && /*#__PURE__*/jsx("i", {
              ref: arrowRef,
              style: {
                left: floating.middlewareData.arrow?.x,
                top: floating.middlewareData.arrow?.y
              },
              className: arrowCls,
              "data-popper-arrow": true,
              "data-placement": floating.placement
            }), props.children]
          })
        })
      })
    })
  });
}

export { Overlay, TRANSITION_DURATION_MS as overlayTransitionDurationMs };
//# sourceMappingURL=overlay.js.map
